import { createHash } from 'crypto';
import { SecureTargetWord } from "./wordUtils";

// Return the hashed form of a letter
export const hashLetter = (salt: string, letter: string): string => {
    // First, hash the salt + letter. SHA-1 is fine here because we're
    // not concerned about cryptographic integrity
    const sha1Hash = createHash('sha1').update(salt + letter).digest();

    // Take the first 3 bytes (24 bits) so that we can fit them into
    // 4 base64 characters. 24 bits gives us a 1 in 2**24 chance of a
    // letter collision in the same word, which is probably low enough
    // to ignore.
    const first24Bits = sha1Hash.slice(0, 3);
    return first24Bits.toString('base64');
}

const isStringArray = (value: unknown): value is string[] => {
    return Array.isArray(value) && value.every(item => typeof item === 'string');
}

export const isSecureTargetWord = (targetWord: unknown): targetWord is SecureTargetWord => {
    if (typeof targetWord !== 'object' || targetWord === null) return false;

    const candidate = targetWord as Partial<SecureTargetWord>;
    return typeof candidate.salt === 'string' && isStringArray(candidate.hashedLetters);
}

export const bruteForceLetter = (salt: string, hash: string): string => {
    const letters = "abcdefghijklmnopqrstuvwxyz";

    for (const letter of letters) {
        if (hashLetter(salt, letter) === hash) {
            return letter;
        }
    }
}

export const bruteForceWord = (targetWord: SecureTargetWord): string => {
    let word = "";
    for (const hash of targetWord.hashedLetters) {
        const letter = bruteForceLetter(targetWord.salt, hash);
        word += letter;
    }

    return word;
}

export const isEmptyWord = (targetWord: unknown): boolean => {
    // Treat malformed/legacy payloads as empty so callers can safely reinitialize.
    if (!isSecureTargetWord(targetWord)) return true;

    return targetWord.hashedLetters.every(hash => hash === '');
}
